export const getIsSaveInvoiceDraft = (state) =>
  state.invoiceReviews.isSaveInvoiceDraft
export const getIsSaveAndSend = (state) => state.invoiceReviews.isSaveAndSend
export const getNavigateToUpdateBankInfo = (state) =>
  state.invoiceReviews.isNavigateToUpdateBankInfo
export const getIsGenerateInvoice = (state) =>
  state.invoiceReviews.isGenerateInvoice
export const getAttachments = (state) => state.invoiceReviews.attachments
export const getAttachedJournalPdfData = (state) =>
  state.invoiceReviews.attachedJournalPdfData
export const getInvoice_id = (state) => state.invoiceReviews.invoice_id
